
import React from 'react';
import { Card } from '@/components/ui/card';
import PaymentOptions from '@/components/payment/PaymentOptions';
import { GrossCalculationResult } from '@/utils/fees/calculators/grossAmountCalculator';

interface PaymentCardSectionProps {
  product: any;
  additionalProducts: any[];
  selectedPaymentMethod: 'bank' | 'card' | null;
  clientSecret: string | null;
  paymentInitialized: boolean;
  processingPayment: boolean;
  paymentError: string | null;
  handlePaymentSelect: (method: 'bank' | 'card') => void;
  initializePayment: any;
  connectedAccountId?: string;
  grossCalculation: GrossCalculationResult;
  hasMixedPaymentTypes: boolean;
  checkoutStripeAccountId?: string; // Added this prop
}

const PaymentCardSection: React.FC<PaymentCardSectionProps> = ({
  product,
  additionalProducts,
  selectedPaymentMethod,
  clientSecret,
  paymentInitialized,
  processingPayment,
  paymentError,
  handlePaymentSelect,
  initializePayment,
  connectedAccountId,
  grossCalculation,
  hasMixedPaymentTypes,
  checkoutStripeAccountId // Allow passing a specific Stripe account ID for checkout
}) => {
  // Use the checkout-specific account if provided, otherwise fall back to the connected account
  const stripeAccountToUse = checkoutStripeAccountId || connectedAccountId;

  return (
    <Card className="p-4 bg-white border rounded-md shadow-sm">
      <h3 className="text-2xl font-semibold mb-4">Payment Options</h3>

      {hasMixedPaymentTypes && (
        <div className="mb-4">
          <p className="text-sm text-gray-500">
            Mixed payment types detected. Please select a payment method that supports all items in your order.
          </p>
        </div>
      )}

      <PaymentOptions
        product={product}
        additionalProducts={additionalProducts}
        onPaymentSelect={handlePaymentSelect}
        selectedPaymentMethod={selectedPaymentMethod}
        clientSecret={clientSecret}
        paymentInitialized={paymentInitialized}
        processingPayment={processingPayment}
        paymentError={paymentError}
        onPaymentSuccess={() => {}}
        hasMixedPaymentTypes={hasMixedPaymentTypes}
        onInitializePayment={initializePayment}
        connectedAccountId={stripeAccountToUse}
        grossCalculation={grossCalculation}
      />
    </Card>
  );
};

export default PaymentCardSection;
